// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listStyles } from "@turnerBlueprint/Overrides/Widgets/Brand/BrandGallery";
import { xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

listStyles.carouselImage = {
    css: css`
        ${({ isCarouselView }: any) =>
            isCarouselView &&
            `
        &,
        &&& picture > img {
            width: 204px !important;
            height: 102px;
            object-fit: contain;
        }
    `}
        & {
            ${xScreen("lte", "md")} {
                width: 156px !important;
            }
        }
    `,
};

listStyles.titleText = {
    variant: "h2",
};

listStyles.slide = {
    css: css`
        display: flex;
        justify-content: center;
    `,
};

listStyles.imageContainer = {
    css: css`
        justify-content: flex-start;
        gap: 24px 22px;
    `,
};

listStyles.imageItem = {
    css: css`
        &&&& {
            padding: 0;
            ${({ width }: any) =>
                width &&
                `
                max-width: ${width}px;
            `}
        }
    `,
};

listStyles.link = {
    css: css`
        ${({ width }: any) =>
            width &&
            `
            width: ${width}px;
            height: ${width}px;
        `}
    `,
};
